import { render, staticRenderFns } from "./CabinCategoryContainer.vue?vue&type=template&id=70d53849&"
import script from "./CabinCategoryContainer.ts?vue&type=script&lang=ts&"
export * from "./CabinCategoryContainer.ts?vue&type=script&lang=ts&"
import style0 from "./CabinCategoryContainer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports